module.exports = __webpack_public_path__ + "static/media/Trading_Up_Desktop_Banner_STAKE@2x.3e0c06a9.webp";